import { Func, Macro } from '../types';
import { and } from './and';
import { bart } from './bart';
import { cast } from './cast';
import { coalesce } from './coalesce';
import { concat } from './concat';
import { convert } from './convert';
import { convertible } from './convertible';
import { date } from './date';
import { datetime } from './datetime';
import { ends_with } from './ends_with';
import { error } from './error';
import { forex } from './forex';
import { if_func } from './if';
import { iferror } from './iferror';
import { inputSilent } from './inputSilent';
import { list } from './list';
import { list_contains } from './list_contains';
import { normalize_string_pv2 } from './normalize_string_pv2';
import { not } from './not';
import { not_null } from './not_null';
import { or } from './or';
import { ref, refSilent } from './ref';
import { starts_with } from './starts_with';

export const functions = new Map(
  Object.entries({
    cast,
    convert,
    bart,
    concat,
    convertible,
    error,
    forex,
    if: if_func,
    iferror,
    'input?': inputSilent,
    list,
    list_contains,
    ref,
    'ref?': refSilent,
    coalesce,
    not_null,
    date,
    datetime,
    normalize_string_pv2,
    and,
    or,
    not,
    ends_with,
    starts_with,
  })
);

let functionOverridesForTests: typeof functions | undefined = undefined;

export function overrideFunctionsForTests(
  overrides: typeof functions | undefined
): void {
  functionOverridesForTests = overrides;
}

export function getFunction(name: string): Func | Macro | undefined {
  if (functionOverridesForTests) {
    const override = functionOverridesForTests.get(name);
    if (override) {
      return override;
    }
  }
  return functions.get(name);
}
